import RightSidebarButton from "@/features/Navigation/components/RightSidebarButton";
import { downloadFile } from "@/utils/misc/downloadFile";
import clsx from "clsx";
import { useApiMutation } from "@/api/hooks/useApiMutation/useApiMutation";
import { downloadFileMutation } from "@/entities/FileService/File.mutations";
import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import { File } from "@/entities/FileService/File.model";
import { useApiQuery } from "@/api/hooks/useApiQuery";
import { getDescendants } from "@/entities/FileService/File.queries";
import { FileLineageTree } from "@/features/FileManagement/components/FileLineageTree/FileLineageTree";
import { parseFileTree } from "@/features/FileManagement/helpers/parseFileTree";
import { useRouter } from "@/utils/router/useRouter";
import { LineageTree } from "@/entities/FileService/File.types";

export function UploadDetailPanel({
    selectedUpload,
}: {
    selectedUpload: File;
}) {
    const router = useRouter();
    const companyId = router.params.companyId as string;
    const { mutate: download } = useApiMutation(downloadFileMutation, {
        onSuccess: (data) => {
            console.log(data, "download success");
            downloadFile(data.presignedUrl);
        },
    });

    const { data: descendants, isLoading } = useApiQuery(getDescendants, {
        params: { fileId: selectedUpload.id },
    });

    return (
        <div
            className={clsx(
                "px-6",
                "absolute inset-0 flex min-h-0 flex-col overflow-hidden",
            )}
        >
            <div className="sticky my-6 flex flex-col">
                <RightSidebarButton />
                <h2 className="pageheading">{selectedUpload.name}</h2>
                <button
                    type="button"
                    className="quiet w-fit"
                    onClick={() => {
                        console.log(selectedUpload, "download");
                        download({
                            fileId: selectedUpload.id,
                        });
                    }}
                >
                    Download <ArrowDownTrayIcon className="size-4" />
                </button>
            </div>
            {!descendants && isLoading && (
                <>
                    {[...Array(3)].map((_, i) => (
                        <div
                            key={i}
                            className={clsx(
                                "bg-selected mb-2 h-10 w-full animate-pulse self-center rounded",
                            )}
                        />
                    ))}
                </>
            )}
            {descendants && (
                <div className="custom-scrollbar hide-scrollbar overflow-y-scroll pb-6">
                    <p className="heading-l pb-4">File lineage</p>
                    <FileLineageTree
                        nodes={parseFileTree(descendants as LineageTree, {
                            source: selectedUpload.source,
                            createdAt: selectedUpload.createdAt,
                            createdBy: selectedUpload.createdByUserId,
                            companyId: companyId,
                        })}
                    />
                </div>
            )}
        </div>
    );
}
